export const HIPAA_BENEFITS: string[] = [
  'benefitItem1',
  'benefitItem2',
  'benefitItem3',
  'benefitItem4',
  'benefitItem5',
  'benefitItem6',
  'benefitItem7',
  'benefitItem8',
  'benefitItem9',
];
